{
    "form_title": "Nouvelle adresse de livraison",
    "form_sub_title": "Elle sera enregistrée dans le système ERP et visible par tous",

    "form_label__address_line_1": "Adresse",
    "form_label__address_line_2": "Adresse 2",
    "form_label__street": "Rue et numéro",
    "form_label__zip_code": "Code postal",
    "form_label__city": "Ville",
    "form_label__country_code": "Pays",

    "form_placeholder__address_line_1": "Exemple Sàrl",
    "form_placeholder__address_line_2": "c/o Exemple Industrie Sàrl",
    "form_placeholder__street": "42 rue de l'Exemple",
    "form_placeholder__zip_code": "1201",
    "form_placeholder__city": "Genève",
    "form_placeholder__country_code": "Suisse"
}
